<template>
    <div class="head-title">
        <div class="left">
            <ul class="breadcrumb">
                <li>
                    <a href="/HomeProperty" class="active">{{ $t("Property") }}</a>
                </li>
                <li>-</li>
                <li>
                    <a class="active">{{ $t("Statement") }} {{ $t("due") }} {{ $t("Rentals") }}</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="main">
        <div class="head">
            <div class="head1">
                <div class="filter-group">
                    <label for="realty-select">{{ $t("realty") }}</label>
                    <v-select
                        id="realty-select"
                        :options="accounts"
                        label="name"
                        v-model="item"
                        class="filter-select"
                        aria-label="Select Realty"
                    >
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group renter-group">
                    <label for="renter-select">{{ $t("renter") }}</label>
                    <v-select
                        id="renter-select"
                        :options="renters"
                        label="name"
                        v-model="selectedRenter"
                        class="filter-select renter-select"
                        aria-label="Select Renter"
                    >
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group">
                    <label for="status-select">{{ $t("status") }}</label>
                    <v-select
                        id="status-select"
                        :options="statuses"
                        label="name"
                        v-model="selectedStatus"
                        class="filter-select"
                        aria-label="Select Status"
                    >
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group">
                    <!-- <label for="from-date">{{ $t("from") }}</label>
                    <input
                        id="from-date"
                        type="date"
                        :placeholder="$t('from')"
                        v-model="from"
                        class="filter-input"
                        aria-label="From Date"
                    /> -->
                    <label for="to-date">{{ $t("to") }}</label>
                    <input
                        id="to-date"
                        type="date"
                        :placeholder="$t('to')"
                        v-model="to"
                        class="filter-input"
                        aria-label="To Date"
                    />
                </div>
                <div class="filter-group">

                </div>
                <button
                    type="submit"
                    @click="submit"
                    class="filter-button search-button"
                    aria-label="Search"
                >
                    <i class="bi bi-search"></i> {{ $t("search") }}
                </button>
                <!-- <button
                    type="submit"
                    @click="getallpayments"
                    class="filter-button search-button"
                    aria-label="Search"
                    v-if="data1.length > 0"
                >
                 تاكيد السداد
                </button> -->
                <button
                    type="submit"
                    @click="exportToExcel"
                    class="filter-button excel-button"
                    aria-label="Export to Excel"
                >
                    <i class="bi bi-file-earmark-excel"></i> Excel
                </button>
            </div>
            <div class="head2">

            </div>
        </div>

        <div class="body" v-if="this.data1.length == 0">
            <br />
            برجاء اختيار اسم العقار
        </div>
        <div class="body" v-if="this.data1.length > 0">
            <br />
            <div style="padding: 2%; direction: rtl; font-size: small">
                <h4>
                    {{ $t("Statement") }} {{ $t("due") }} {{ $t("Rentals") }} -
                    <span>{{ realty }}</span>
                </h4>
                <h6>{{ $t("to") }} : {{ todate }}</h6>

                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t("number") }} {{ $t("contract") }}</th>
                            <th>{{ $t("name") }} {{ $t("realty") }}</th>
                            <!-- <th>{{ $t("date") }} {{ $t("due") }}</th> -->
                            <th>{{ $t("date") }} {{ $t("start") }} {{ $t("contract") }}</th>
                            <th>{{ $t("date") }} {{ $t("end") }} {{ $t("contract") }}</th>
                            <th>{{ $t("number") }} {{ $t("unit") }}</th>
                            <th>{{ $t("name") }} {{ $t("renter") }}</th>
                            <th>{{ $t("amount") }} {{ $t("due") }}</th>
                            <th>اجمالى السداد</th>
                             <th>المتبقى</th>
                            <th>اجمالى  العمولات</th>
                            <th>اجمالى السداد العمولات</th>
                            <th>المتبقى من العمولات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in data1" :key="i">
                            <td>
                                <router-link to="">{{ i.conid }}</router-link>
                            </td>
                            <td>{{ i.propertyname }}</td>
                            <!-- <td>{{ i.duedate }}</td> -->
                            <td>{{ i.contstart }}</td>
                            <td>{{ i.contend }}</td>
                            <td>{{ i.unite }}</td>
                            <td>{{ i.rentername }}</td>
                            <td>{{ i.dueamount }}</td>
                            <td>{{ i.paid }}</td>
                            <td> {{ i.totalchange}}</td>
                            <td>{{ i.allduocommission }}</td>
                            <td> {{ i.paidcom }}</td>
                            <td>{{ i.totalchangecom }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="buttom">
            <button class="buttonconfirm" type="submit" v-if="this.view != 0" @click="pdf">
                <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
            </button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import html2pdf from "html2pdf.js";
import store from "@/store";
// var tafqeet = require("../../TafqeetJs-master/Tafqeet");
import * as XLSX from "xlsx";
//  import "moment/locale/ar";
export default {
  components: {
    vSelect,
  },
  async mounted() {
    // Fetch properties
    // moment.locale("ar");
    const result2 = await axios.get("/data/getallproperty");
    if (result2.status == 200) {
      const accounts = result2.data.data;
      for (let i = 0; i < accounts.length; i++) {
        this.accounts.push({ name: accounts[i].name, pid: accounts[i].pid });
      }
    }

    // Fetch renters
    const resultRenters = await axios.get("/data/getallrenters");
    if (resultRenters.status == 200) {
      const renters = resultRenters.data.data;
      this.renters = [{ name: "كل المستأجرين", renterid: "all" }];
      for (let i = 0; i < renters.length; i++) {
        this.renters.push({ name: renters[i].rentername, renterid: renters[i].renterid });
      }
    }




    this.url = store.state.imgurl + `/clogo/${this.$store.state.cnum[0].cnum}.png`;
  },
  props: ["css"],
  data() {
    return {
      item: {},
      fromdate: "",
      selectedRenter: null,
      selectedStatus: null,
      renters: [{ name: "كل المستأجرين", renterid: "all" }],
      statuses: [{ name: "كل الحالات", status: "all" },{name: "فعال", status: "active"},{ name: "منتهى", status: "archive"}],
      todate: "",
      data1: [],
      allinstallment: [],
      view: "",
      namear: "",
      nameen: "",
      typeact: "",
      accounts: [{ name: "كل العقارات", pid: "all" }],
      realty: "",
      totaldue: 0,
      textamount: "",
      commission: [],
      conttype: "",
      id: "",
      rentername: "",
      unite: "",
      propertyname: "",
      igarnumber: "",
      contstart: "",
      comend: "",
      from: "",
      to: "",
      loginUser: store.state.randp.username,
    };
  },
  methods: {
    async submit() {
      if (this.to) {
        const renterId = this.selectedRenter ? this.selectedRenter.renterid : "all";
        const status = this.selectedStatus ? this.selectedStatus.status : "all";
        const result = await axios.get(
          `/reports/rentalstatementcontracts/${this.to}/${this.item.pid}/${renterId}/${status}`
        );
        if (result.status == 200) {
          this.data1 = result.data.data;
          this.realty = this.item.name;
          this.fromdate = this.from;
          this.todate = this.to;
        }
      }
    },
    exportToExcel() {
      var data = [];
      for (let i = 0; i < this.data1.length; i++) {
        const name = this.data1[i];
        data.push({
          رقم_العقد: name.conid,
          اسم_العقار: name.propertyname,
          تاريخ_بدا_العقد: name.contstart,
          تاريخ_نهاية_العقد: name.contend,
          رقم_الوحدة: name.unite,
          اسم_المستاجر: name.rentername,
          مبلغ_الاستحقاق: name.dueamount,
          السداد : name.totalchange,
          المتبقى_من_السداد : name.paid,
          اجمالى_العمولات:name.allduocommission,
          السداد_العمولات : name.paidcom,
     المتبقى_من_العمولات : name.totalchangecom
        });
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `statement${this.item.name}.xlsx`);
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.5,
        filename: `استحقاق.pdf`,
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
  },
  watch: {
    item() {
      this.data1 = [];
      this.from = "";
      this.to = "";
    },
    selectedRenter() {
      this.data1 = [];
      this.from = "";
      this.to = "";
    },
    selectedStatus() {
      this.data1 = [];
      this.from = "";
      this.to = "";
    },
  },
  computed: {
    currentDate() {
      return moment().format("DD MMMM YYYY"); // e.g., "10 مايو 2025"
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
    padding: 0.5%;
}

.main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.head {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #dee2e6;
    background-color: #f9fafb;
    border-radius: 8px 8px 0 0;
}

.head1 {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    align-items: flex-end;
}

.filter-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
    width:50%;
}

.renter-group {
    min-width: 300px; // Slightly larger for renters dropdown
}

.filter-group label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0.375rem;
    transition: color 0.2s;
}

.filter-select {
    background-color: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 6px;
    padding: 0.625rem;
    font-size: 0.9rem;
    transition: border-color 0.3s, box-shadow 0.3s, transform 0.2s;
}

.renter-select {
    min-width: 180px; // Ensure renters dropdown is slightly larger
}

.filter-select:focus {
    border-color: #6299ae;
    box-shadow: 0 0 0 4px rgba(98, 153, 174, 0.15);
    outline: none;
    transform: translateY(-1px);
}

.select-option {
    text-align: center;
    padding: 0.625rem;
    color: #2c3e50;
    transition: background-color 0.2s;
}

.select-option:hover {
    background-color: #f1f5f9;
}

.filter-input {
    padding: 0.625rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 0.9rem;
    background-color: #ffffff;
    transition: border-color 0.3s, box-shadow 0.3s, transform 0.2s;
}

.filter-input:focus {
    border-color: #6299ae;
    box-shadow: 0 0 0 4px rgba(98, 153, 174, 0.15);
    outline: none;
    transform: translateY(-1px);
}

.filter-button {
    padding: 0.625rem 1.25rem;
    border: none;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.625rem;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;
}

.search-button {
    background-color: #6299ae;
    color: #ffffff;
}

.search-button:hover {
    background-color: #527b8e;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.excel-button {
    background-color: #28a745;
    color: #ffffff;
}

.excel-button:hover {
    background-color: #218838;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.filter-button i {
    font-size: 1.1rem;
}

.head2 {
    display: flex;
    align-items: flex-end;
}

.table {
    margin-top: 1%;
}

table thead tr {
    border-radius: 5px;
    background-color: #eee;
}

.modhead {
    display: flex;
}

.modhead .part {
    width: 75%;
    //padding-top: 5%;
    font-size: large;
}

.modhead .logo {
    width: 25%;
}

.modhead img {
    width: 100%;
}

@media screen and (max-width: 768px) {
    .head {
        padding: 1rem;
    }

    .head1 {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .filter-group, .renter-group {
        min-width: 100%;
    }

    .filter-button {
        width: 100%;
        justify-content: center;
        padding: 0.75rem;
    }

    .head2 {
        width: 100%;
        justify-content: center;
        margin-top: 1.25rem;
    }
}

@media screen and (max-width: 576px) {
    .table {
        width: 90%;
        margin-left: 5%;
        margin-right: 5%;
        background-color: white;
        font-size: xx-small;
    }

    .filter-group label {
        font-size: 0.85rem;
    }

    .filter-select, .filter-input {
        font-size: 0.85rem;
        padding: 0.5rem;
    }
}
</style>
